import styled from 'styled-components';

export const StyledAppointmentConfirmationStatusField = styled.div`
   width: 248px;
`;
StyledAppointmentConfirmationStatusField.displayName = 'StyledAppointmentConfirmationStatusField';
